import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: Arial,'Helvetica Neue', Helvetica, sans-serif;
  }

  body.fontLoaded {
    font-family: 'Arial', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif;
  }

  #app {
    background-color: #fff;
    // min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: 'Arial', Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0; 
  }
`;



// WEBPACK FOOTER //
// ./app/global-styles.js